<template>
  <div id="app">
    <Sidebar 
      v-show="!isSidebarHidden"
      @onSelectElementOfList="onSelectElementOfList" />
    <MapComponent />
    <CurrentLocation />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import Sidebar from "@/components/Sidebar";
import MapComponent from "@/components/MapComponent";
import CurrentLocation from "@/components/CurrentLocation";

import consumer from "@/modules/consumer";

/**
 * Json
 */
//const json_cities = require("@/assets/json/cities.json")
const userMarkerIcon = require("@/assets/images/bluecircle.png");
const puntoRedIcon = require("@/assets/images/punto_red_marker.png");
const defaultImage = require("@/assets/images/default.gif");
const placeImage = require("@/assets/images/icons8-marker-48.png");

export default {
  name: "app",
  components: {
    Sidebar,
    MapComponent,
    CurrentLocation
  },
  data: () => ({
    windowWidth: 0,
    windowHeight: 0
  }),
  watch: {
    windowWidth: val => {}
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.fillDimensions);
      this.fillDimensions();
    });

    /**
    * Load Departments
    */
    consumer.getDepartments().then(resp => {
      var departments = resp.data.data.departments;
      this.$store.commit("departments/setDepartments", departments);
    });

    /**
     * Load The Cities
     */

    consumer.getCities().then(resp => {
      var cities = resp.data.data.results;
      this.$store.commit("cities/setCities", cities);
    });

    /**
     * Get Categories
     */
    consumer.getCategories().then(resp => {
      var categories = resp.data.data.results;
      this.$store.commit("categories/setCategories", categories);
    });
  },
  computed: {
    ...mapGetters("interface", {
        isSidebarHidden: 'isSidebarHidden'
    })
  },
  methods: {
    fillDimensions(e) {
      this.windowWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;

      this.windowHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;

      if (this.windowWidth <= 780) {
        this.$store.commit("interface/setIsDimensionResponsive", true);
        this.hideSidebar();
      } else {
        this.$store.commit("interface/setIsDimensionResponsive", false);
        this.showSidebar();
      }
    },
    paintPlaceAround(place, points, distance) {
      points = points.filter((p) => {return p.DISTANCIA <= distance;});
      if (!points || points.length == 0) {
        alert("No se encontraron puntos cerca de esta ubicación.");
        return;
      }
      const { location } = place.geometry;
      var self = this;
      self.setSidebarModeResults();
      this.setCurrentPoints(points);
      this.paintPoints(points);
      this.paintCircleAround(location, distance);
      /*** */
      window.mapInstance.addMarker("-1", location, {
        icon: placeImage,
        title: place.name
      });
    },
    paintCircleAround(center, population) {
      window.mapInstance.addCircle("CIRCLE_AROUND", center, population, {
        strokeColor: '#343a40',
        strokeOpacity: 0.2,
        strokeWeight: 2,
        fillColor: '#17a2b8',
        fillOpacity: 0.2
      });
    },   
    onSelectElementOfList(point) {        
        window.mapInstance.setCenter(parseFloat(point.cx), parseFloat(point.cy), 20);
        var marker = window.mapInstance.markers[point.puntored_id];
        if (marker) {
            new google.maps.event.trigger( marker, 'click' );
        }
    },
    paintPoints(points) {
      window.mapInstance.cleanAllMarkers();
      window.mapInstance.cleanPolygons();
      var bounds = window.mapInstance.createBounds();
      var validPoints = false;
      for (var i in points) {
        var point = points[i];
        const {cx, cy} = point;
        if(cx && cy){
          var latLng = {
            lat: parseFloat(point.cy),
            lng: parseFloat(point.cx)
          };
          bounds.extend(latLng);
          this.paintPoint(latLng, point);
          validPoints = true;
        }        
      }
      if(validPoints)
        window.mapInstance.fitBounds(bounds);
    },
    paintPoint(latLng, point) {
      window.mapInstance.addMarker(point.puntored_id, latLng, {
        icon: puntoRedIcon,
        title: point.nombre_comercial,
        infowin: this.infowinPoint(point),
        markerOptions: {
          zIndex: 100
        }
      });
    },
    infowinPoint({
      direccion,
      imagen,
      nombre_ciudad,
      nombre_comercial,
      nombre_departamento,
      horario,
      cx,
      cy
    }) {
      if (!imagen) {
        imagen = defaultImage;
      }
      if (!nombre_comercial) {
          nombre_comercial = direccion;
      }
      return `
          <div class="infowin_point">
            <h1>${nombre_comercial}</h1>
            <figure>
                <img src="${imagen}" alt="Imagen del punto"/>
            </figure>
            <ul>
                <li>
                  <strong>Dirección: </strong>
                  <span>${direccion}</span>
                </li>
                <li>
                  <strong>Horario: </strong>
                  <span>${horario}</span>
                </li>
                <li>
                  <strong>Ciudad: </strong>
                  <span>${nombre_ciudad}</span>
                </li>
                <li>
                  <strong>Departamento: </strong>
                  <span>${nombre_departamento}</span>
                </li>
                <li>
                  <button 
                    type="button" 
                    class="btn-gmaps btn btn-primary btn-sm"
                    onclick="OpenInGoogleMaps(${cy},${cx})"
                    >Ver en Google Maps</button>
                </li>
            </ul>
          </div>
      `;
    },
    ...mapActions("points", {
      'setCurrentPoints': "setCurrentPoints"
    }),
    ...mapActions("interface", {
      setSidebarModeFilters: "setSidebarModeFilters",
      setSidebarModeResults: "setSidebarModeResults",
      hideSidebar: "hideSidebar",
      showSidebar: "showSidebar"
    }),
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.fillDimensions);
  }
};
</script>

<style lang="scss">
</style>
